import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'numbers',
  size: 24,
  node: [
    ['path', { d: 'm10 4 2.6-1.95a.25.25 0 01.4.2V10', key: '13vgod' }],
    [
      'path',
      { d: 'M16 14.535A4 4 0 0118 14a2 2 0 010 4 2 2 0 010 4 4 4 0 01-2-.535', key: '8az2h7' },
    ],
    [
      'path',
      {
        d: 'M8 22H4.5a.5.5 0 01-.5-.5c0-2.68 4-2.932 4-5.5a2 2 0 00-2-2 2.5 2.5 0 00-2 1',
        key: '110tub',
      },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Numbers
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAgNCAyLjYtMS45NWEuMjUuMjUgMCAwMS40LjJWMTAiIC8+CiAgPHBhdGggZD0iTTE2IDE0LjUzNUE0IDQgMCAwMTE4IDE0YTIgMiAwIDAxMCA0IDIgMiAwIDAxMCA0IDQgNCAwIDAxLTItLjUzNSIgLz4KICA8cGF0aCBkPSJNOCAyMkg0LjVhLjUuNSAwIDAxLS41LS41YzAtMi42OCA0LTIuOTMyIDQtNS41YTIgMiAwIDAwLTItMiAyLjUgMi41IDAgMDAtMiAxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/numbers
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Numbers = createLucideIcon(__iconData);

export default Numbers;
